import React from 'react';
import {
  Routes as RoutesDom,
  Route,
} from 'react-router-dom';

import { PathName } from 'appConstants';
import { useScrollToTop } from 'hooks';

import { WelcomeLayout, MainLayout } from 'layouts';
import {
  ForgotPasswordPage,
  HomePage,
  RegistrationPage,
  SignInPage,
  EclipseDrivePage,
  ProfilePage,
  PartnerPage,
  TransactionsPage,
  SupportPage,
  SupportTicketPage,
  NotFoundPage,
  StatusPage,
  PoolPage,
  NewsPage,
  NewsItemPage,
  InstrumentsPage,
  FAQPage,
  DocumentsPage,
  DocumentItemPage,
} from 'pages';

export const Routes = () => {
  useScrollToTop();
  return (
    <RoutesDom>
      <Route
        path={PathName.Home}
        element={<WelcomeLayout />}
      >
        <Route
          path={PathName.Home}
          element={<HomePage />}
        />
        <Route
          path={PathName.HomeFooter}
          element={<HomePage goingFooter />}
        />
        <Route
          path={PathName.Registration}
          element={<RegistrationPage />}
        />
        <Route
          path={PathName.SignIn}
          element={<SignInPage />}
        />
        <Route
          path={PathName.ForgotPassword}
          element={<ForgotPasswordPage />}
        />
        <Route
          path={PathName.EclipseDrive}
          element={<EclipseDrivePage />}
        />
      </Route>
      <Route
        path={PathName.Cabinet}
        element={<MainLayout />}
      >
        <Route
          path={PathName.EclipseDriveAuth}
          element={<EclipseDrivePage />}
        />
        <Route
          path={PathName.Profile}
          element={<ProfilePage />}
        />
        <Route
          path={PathName.Partner}
          element={<PartnerPage />}
        />
        <Route
          path={PathName.Status}
          element={<StatusPage />}
        />
        <Route
          path={PathName.Pool}
          element={<PoolPage />}
        />
        <Route
          path={PathName.Transactions}
          element={<TransactionsPage />}
        />
        <Route
          path={PathName.News}
          element={<NewsPage />}
        />
        <Route
          path={PathName.NewsItem}
          element={<NewsItemPage />}
        >
          <Route
            path={PathName.ItemId}
            element={<NewsItemPage />}
          />
        </Route>
        <Route
          path={PathName.Instruments}
          element={<InstrumentsPage />}
        />
        <Route
          path={PathName.Support}
          element={<SupportPage />}
        />
        <Route
          path={PathName.Support}
          element={<SupportTicketPage />}
        >
          <Route
            path={PathName.ItemId}
            element={<SupportTicketPage />}
          />
        </Route>
        <Route
          path={PathName.Faq}
          element={<FAQPage />}
        />
        <Route
          path={PathName.Documents}
          element={<DocumentsPage />}
        />

        <Route
          path={PathName.DocumentsItem}
          element={<DocumentItemPage />}
        >
          <Route
            path={PathName.ItemId}
            element={<DocumentItemPage />}
          />
        </Route>
        <Route
          element={<NotFoundPage />}
          path="*"
        />
      </Route>
      <Route
        element={<NotFoundPage />}
        path="*"
      />
    </RoutesDom>
  );
};
